<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue